export default __webpack_public_path__ + "static/media/SIN_PRO_SN_700x400px.7225211c.png";